import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/config'; // Initialize i18n
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { initAnalytics } from './lib/analytics';

initAnalytics();

const container = document.getElementById('root') as HTMLElement;

const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// scripts/prerender.mjs writes static HTML for the public routes so that
// crawlers which don't run JavaScript still see the page. Those head tags are
// a snapshot of what components/SEO.tsx produced; React is about to hoist its
// own copies, so drop the snapshot first or the document ends up with two
// <title>/description/canonical tags and a stale title after client-side
// navigation. Removing them costs nothing visually — React re-adds them in the
// same task, before the next paint.
document.querySelectorAll('head [data-prerendered]').forEach((el) => el.remove());

// Note: this deliberately does NOT hydrate. hydrateRoot expects markup from
// React's own server renderer, including its Suspense boundary markers; a DOM
// snapshot taken from a headless browser has none of those, so hydration fails
// with React error #418 on every route and falls back to a client render anyway
// — just noisily, and after re-adding duplicate head tags. createRoot discards
// the prerendered DOM cleanly, which is all we need: the prerender exists for
// crawlers, not to save the browser work.
ReactDOM.createRoot(container).render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
